$(document).ready(function () {

    if ($('#agencies_table').length) {

        let url = window.location.origin + '/agencies/get';

        setTimeout(function () {
            agencies_table();
        }, 500);

        function agencies_table() {
            const dataTable = $('#agencies_table').dataTable({
                "processing": true,
                "serverSide": true,
                "ajax": url,
                "columns": [
                    {data: 'id'},
                    {data: 'nombre'}
                ],
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "render": function (data, type, row, meta) {
                            return "";
                        }
                    },

                    {
                        "targets": 2,
                        "render": function (data, type, row, meta) {
                            return  "<button type='button' class='btn btn-primary btn-sm edit-agencies' data-toggle='tooltip' data-placement='top' title='Editar dependencia' data-agencies='" + row + "'><i class='fas fa-pencil'></i></button> ";
                        },
                        "className": "text-center"
                    }],
                "language": {
                    "url": window.location.origin + "/json/Spanish.json"
                },
            });

            dataTable.on('draw.dt', function () {
                $('[data-toggle="tooltip"]').tooltip({
                    trigger: 'hover'
                });
            });

            $('#agencies_table tbody').on('click', '.edit-agencies', function (e) {
                e.preventDefault();
                let table = $("#agencies_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                $.ajax({
                    url: window.location.origin + '/agencies/' + rowData.id + '/edit',
                    type: 'GET',
                })
                    .done(function (response) {
                        $('#div_modal_agencies').html(response);
                        $('#modal-agencies').modal("show");
                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
            });
        }

        $(".add_agencies").on('click', function () {

            $.ajax({
                url: window.location.origin + '/agencies/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_agencies').innerHTML = response;
                    $('#modal-agencies').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });

        });


        $(document).on('click', '#send_agencies', function (event) {
            event.preventDefault();

            let url = window.location.origin + '/agencies';
            let formData = new FormData();

            formData.append('nombre', $("#nombre").val());
            document.getElementById('div_message').innerHTML = "";

            $.ajax({
                data: formData,
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Agregado', ' Se agrego la dependen ciaa correctamente', 'success')
                        .then(() => {
                            $('#modal-agencies').modal("hide");
                            let url = window.location.origin + '/agencies/get';
                            $('#agencies_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class=''>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        $(document).on('click', '#send_agencies_update', function (event) {

            event.preventDefault();
            let id = $("#id").val();

            let url = window.location.origin + '/agencies/' + id;
            let formData = new FormData();

            formData.append('id', $("#id").val());
            formData.append('nombre', $("#nombre").val());
            formData.append('_method', 'PUT'); //requerido para enviar el archivo se tiene que usar post en ajax

            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: formData,
                url: url,
                //type: 'PUT',
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {

                    if (typeof response['status'] !== 'undefined') {
                        Swal.fire('Advertencia', response['message'], 'info')
                            .then(() => {
                                location.reload();
                            });
                    } else {
                        Swal.fire('Actualizado', 'Se actualizo el usuario correctamente', 'success')
                            .then(() => {
                                $('#modal-agencies').modal("hide");
                                let url = window.location.origin + '/agencies/get';
                                $('#agencies_table').DataTable().ajax.url(url).load();
                            });
                    }

                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class=''>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });


    }
});
